

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Action, Mutation } from "vuex-class"

import FileUpload from "@/mixins/FileUpload"

import vSelect from "vue-select"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"

import CaseFileUpload from "./Files/CaseFileUpload.vue"
import CaseFileDisplay from "./Files/CaseFileDisplay.vue"
import KeyMedia from "./KeyMedia.vue"

import { CaseDetails, CaseField, CaseAudit } from "@/types"
import CaseFile from "@/types/caseFile"

import api from "@/services/api"
const caseStore = namespace("cases")

@Component({
	components: {
		"v-select": vSelect,
		"scrollbar": VuePerfectScrollbar,
		"case-file": CaseFileDisplay,
		"file-upload": CaseFileUpload,
		"key-media": KeyMedia
	}
})
export default class CaseFiles extends FileUpload {
	@Prop()
	public currentCase: any;

	@Prop()
	canEditCurrentCase!: boolean;

	@Prop({ type: Boolean, default: false })
	public showFileUpload!: boolean;

	@Prop({ type: Boolean, default: false })
	public displayAsList!: boolean;

	@Prop()
	public caseFiles!: CaseFile[];

	@caseStore.Getter("getKeyMedia")
	public keyMedia!: any[];

	@caseStore.Mutation
	public setShowCCEvent!: (ccEvent: any) => void;

	creatingNewCase: boolean = false;

	private get caseId (): string {
		if (!this.currentCase) {
			return ""
		}

		return this.currentCase.id
	}

	public downloadFile (fileId: string) {
		// Create a link and trigger a click to do the normal browser downloady thing
		let downloadUrl = api.baseUrl + "files/download/" + fileId

		let link = document.createElement("a")
		link.href = downloadUrl
		link.download = downloadUrl
		link.click()
	}

	/**
	 * Open CC event into modal
	 */
	public openEvent () {
		this.setShowCCEvent(this.currentCase.originatingEvents[0])
	}

	private get noFieldFiles (): CaseFile[] {
		if (this.caseFiles == null) {
			return []
		}
		return this.caseFiles.filter(caseFile => !caseFile.fieldId)
	}
}
